import { Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import Dashboard from './pages/Dashboard'
import PrefectureDashboard from './pages/PrefectureDashboard'
import ArticleList from './pages/ArticleList'
import ArticleDetail from './pages/ArticleDetail'
import SpreadsheetConverter from './pages/SpreadsheetConverter'
import AdminAccess from './pages/AdminAccess'
import Navigation from './components/layout/Navigation'
import { isFeatureEnabled } from './config/features'
import './App.css'

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <Navigation />
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/prefecture-dashboard" element={<PrefectureDashboard />} />
          <Route path="/articles" element={<ArticleList />} />
          <Route path="/article/:id" element={<ArticleDetail />} />
          <Route path="/admin" element={<AdminAccess />} />
          {isFeatureEnabled('converter') && (
            <Route path="/converter" element={<SpreadsheetConverter />} />
          )}
        </Routes>
      </div>
    </HelmetProvider>
  )
}

export default App
